import CardEController from "./CardEController";

export default CardEController;
